<template>
  <div class="role-edit">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t("system.Role.Return_to_role_list")}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100">
            <FormItem :label="$t('system.Role.name')">
              <Input v-model="name" :placeholder="$t('system.Role.please_enter')"></Input>
            </FormItem>
            <Transfer :data="permissionsData" :operations="[$t('system.Role.Move_left'),$t('system.Role.Move_right')]"
            :target-keys="targetKeys" :list-style="listStyle"
            filterable @on-change="handleChange" :render-format="renderFormat"
            :titles="[$t('system.Role.All_authorization'), $t('system.Role.Role_authorization')]">
            </Transfer>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t("system.Role.save")}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
import store from '@/store'

export default {
  data () {
    return {
      id: Number(this.$route.params.id),
      name: '',
      targetKeys: [],
      listStyle: {
        width: '200px',
        height: '350px',
        'text-align': 'left'
      }
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('system.Role.New_Role') : this.$t('system.Role.edit_Role')
    },
    permissions () {
      return this.$store.getters.permissions
    },
    permissionsData () {
      let data = []
      // let per = this.permissions
      let per = []
      per.super_admin = this.$t('Permission.super_admin')
      per.system = this.$t('Permission.system')
      per.device = this.$t('Permission.device')
      per.card = this.$t('Permission.card')
      per.people = this.$t('Permission.people')
      per.product = this.$t('Permission.product')
      per.order = this.$t('Permission.order')
      per.production_plan = this.$t('Permission.production_plan')
      per.monitor = this.$t('Permission.monitor')
      per.report_export = this.$t('Permission.report_export')
      for (var key in per) {
        data.push({key: key + '-1', label: per[key] + '-' + this.$t('Permission.R')})
        data.push({key: key + '-2', label: per[key] + '-' + this.$t('Permission.W')})
      }
      return data
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let permissions = []
      let permissionsTemp = {}
      for (var per of this.targetKeys) {
        let val = per.split('-')
        if (permissionsTemp[val[0]] === undefined) {
          permissionsTemp[val[0]] = Number(val[1])
        } else {
          permissionsTemp[val[0]] += Number(val[1])
        }
      }
      for (var key in permissionsTemp) {
        permissions.push({action: key, value: permissionsTemp[key]})
      }
      Api.role.save({id: this.id, name: this.name, permissions: permissions}).then(() => {
        this.$router.push({'name': 'Role'})
      })
    },
    handleChange (newTargetKeys) {
      this.targetKeys = newTargetKeys
    },
    renderFormat (item) {
      return item.label
    }
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (!store.getters.permissionsInited) {
      store.dispatch('InitPermissions')
    }
    if (id !== 0) {
      Api.role.get(id).then(res => {
        let targetKeys = []
        for (var per of res.role.permissions) {
          if (per.value === 3) {
            targetKeys.push(per.action + '-1')
            targetKeys.push(per.action + '-2')
          } else {
            targetKeys.push(per.action + '-' + per.value)
          }
        }
        next(vm => {
          vm.name = res.role.name
          vm.targetKeys = targetKeys
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .role-edit {
    padding: 10px
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 40px
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// RoleEdit.vue?5b631a7e